import React from 'react';
import PropTypes from 'prop-types';

const radioItemPropTypes = {
    className: PropTypes.string,
    checked: PropTypes.bool,
    onClick: PropTypes.func.isRequired,
    onKeyDown: PropTypes.func.isRequired,
    checkedIconClass: PropTypes.string,
    uncheckedIconClass: PropTypes.string,
    children: PropTypes.string.isRequired,
    labelId: PropTypes.string.isRequired,
    labelIconClass: PropTypes.string,
};

const radioItemDefaultProps = {
    className: '',
    checked: false,
    checkedIconClass: 'fa fa-dot-circle-o',
    uncheckedIconClass: 'fa fa-circle-o',
    labelIconClass: '',
};

export function RadioItem(props) {
    return (
        <span
            role="radio"
            aria-checked={props.checked}
            tabIndex="0"
            className={`exp-selectable ${props.className}`}
            onClick={props.onClick}
            onKeyDown={props.onKeyDown}
        >
            {props.checked ?
                <span className={props.checkedIconClass} aria-hidden="true" />
                :
                <span className={props.uncheckedIconClass} aria-hidden="true" />
            }
            {!!props.labelIconClass &&
                <span className={props.labelIconClass} aria-hidden="true" />
            }
            <span id={props.labelId}>{props.children}</span>
        </span>
    );
}

RadioItem.propTypes = radioItemPropTypes;
RadioItem.defaultProps = radioItemDefaultProps;

const expanableItemPropTypes = {
    className: PropTypes.string,
    expanded: PropTypes.bool,
    disabled: PropTypes.bool,
    onClick: PropTypes.func.isRequired,
    onKeyDown: PropTypes.func.isRequired,
    expandedIconClass: PropTypes.string,
    unexpandedIconClass: PropTypes.string,
    label: PropTypes.string.isRequired,
    labelId: PropTypes.string.isRequired,
    labelIconClass: PropTypes.string,
    children: PropTypes.node,
};

const expanableItemDefaultProps = {
    className: '',
    expanded: false,
    disabled: false,
    expandedIconClass: "fa fa-fw fa-caret-down",
    unexpandedIconClass: "fa fa-fw fa-caret-right",
    labelIconClass: '',
    children: null,
};

export function ExpandableItem(props) {
    function _onClick(e) {
        if (!props.disabled) props.onClick(e);
    }

    function _onKeyDown(e) {
        if (!props.disabled) props.onKeyDown(e);
    }

    return (
        <span
            role="button"
            tabIndex="0"
            disabled={props.disabled}
            aria-disabled={props.disabled}
            className={`exp-expandable ${props.className}`}
            onClick={_onClick}
            onKeyDown={_onKeyDown}
            aria-expanded={props.expanded}
        >
            {props.expanded ?
                <span className={props.expandedIconClass} aria-hidden="true" />
                :
                <span className={props.unexpandedIconClass} aria-hidden="true" />
            }
            {!!props.labelIconClass &&
                <span className={props.labelIconClass} aria-hidden="true" />
            }
            <span id={props.labelId}>{props.label}</span>
            {props.children}
        </span>
    );
}

ExpandableItem.propTypes = expanableItemPropTypes;
ExpandableItem.defaultProps = expanableItemDefaultProps;

const expandableRadioItemPropTypes = {
    className: PropTypes.string,
    expanded: PropTypes.bool,
    onExpandClick: PropTypes.func.isRequired,
    onExpandKeyDown: PropTypes.func.isRequired,
    expandDisabled: PropTypes.bool,
    expandedIconClass: PropTypes.string,
    unexpandedIconClass: PropTypes.string,
    label: PropTypes.string.isRequired,
    labelId: PropTypes.string.isRequired,
    labelIconClass: PropTypes.string,
    checked: PropTypes.bool,
    onRadioClick: PropTypes.func.isRequired,
    onRadioKeyDown: PropTypes.func.isRequired,
    checkedIconClass: PropTypes.string,
    uncheckedIconClass: PropTypes.string,
};

const expandableRadioItemDefaultProps = {
    className: '',
    expanded: false,
    expandDisabled: false,
    expandedIconClass: 'fa fa-fw fa-caret-down',
    unexpandedIconClass: 'fa fa-fw fa-caret-right',
    labelIconClass: '',
    checked: false,
    checkedIconClass: 'fa fa-dot-circle-o',
    uncheckedIconClass: 'fa fa-circle-o',
};

export function ExpandableRadioItem(props) {
    function _onExpandClick(e) {
        if (!props.expandDisabled) props.onExpandClick(e);
    }

    function _onExpandKeyDown(e) {
        if (!props.expandDisabled) props.onExpandKeyDown(e);
    }

    return (
        <span className={props.className}>
            <span
                role="button"
                tabIndex="0"
                className="exp-expandable"
                disabled={props.expandDisabled}
                aria-disabled={props.expandDisabled}
                onClick={_onExpandClick}
                onKeyDown={_onExpandKeyDown}
                aria-expanded={props.expanded}
                aria-label={`Expand/Collapse ${props.label}`}
            >
                {props.expanded ?
                    <span className={props.expandedIconClass} aria-hidden="true" />
                    :
                    <span className={props.unexpandedIconClass} aria-hidden="true" />
                }
            </span>
            <span
                role="radio"
                aria-checked={props.checked}
                tabIndex="0"
                className="exp-selectable"
                onClick={props.onRadioClick}
                onKeyDown={props.onRadioKeyDown}
            >
                {props.checked ?
                    <span className={props.checkedIconClass} aria-hidden="true" />
                    :
                    <span className={props.uncheckedIconClass} aria-hidden="true" />
                }
                {!!props.labelIconClass &&
                    <span className={props.labelIconClass} aria-hidden="true" />
                }
                <span id={props.labelId}>{props.label}</span>
            </span>
        </span>
    );
}

ExpandableRadioItem.propTypes = expandableRadioItemPropTypes;
ExpandableRadioItem.defaultProps = expandableRadioItemDefaultProps;